<template>
  <div class="qrcode" v-show="codeUrl">
     <div class="imgwrap">
        <img @click="closeWrap" src="./img/close.png" class="closeImg" />
        <img v-if="codeUrl" :src="codeUrl" class="codeurl" />
     </div>
     <p class="info">长按保存二维码</p>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'qrcode',
  props: {
    channel: { // 为了解决列表和详情都监听事件后面取消事件监听的问题
      type: String,
      default: 'list'
    }
  },
  data () {
    return {
      codeUrl: ''
    }
  },
  deactivated () {
    this.codeUrl = ''
  },
  destroyed () {
    console.log(this.channel)
    this.$bus.off(this.channel + 'qrcode')
  },
  created () {
    console.log('我被创建了')
    this.$bus.on(this.channel + 'qrcode', this.geturl)
    console.log(this.$bus)
  },
  methods: {
    ...mapActions(['getQrcodeA']),
    geturl (...args) {
      const [project_no] = args
      this.getQrcodeA(project_no).then(res => {
        const { qr_code_url } = res
        this.codeUrl = qr_code_url
      })
    },
    closeWrap () {
      this.codeUrl = ''
    }
  }
}
</script>

<style scoped>
.qrcode{
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.4);
  position: fixed;
  top:0;
  left:0;
  z-index: 2;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.info{
  font-size: 0.26rem;
  color: white;
  text-align: center;
  margin-top: 0.32rem;
}
.codeurl{
  display: block;
  object-fit: contain;
  width: 5.6rem;
  height:7.8rem;
}
.imgwrap{
  position: relative;
}
.closeImg{
  width: 0.42rem;
  height: 0.42rem;
  padding:0.1rem;
  position:absolute;
  top:0;
  right:0;
}
</style>
